const ASSETS_TAB_INDEX = {
  portfolio: 0,
  optionPositions: 1,
  orders: 2,
  summarize: 3,
  embeddedPutOption: 4,
} as const;

const SETTLEMENT_DUE_TODAY_IN_DAYS = 0;

const HOME_PANE_LAYOUT_DESIGN_SYSTEM_SETTINGS = {
  paddingForPanesSize: 3,
  bottomSectionMinHeightPx: 52,
  collapsedSize: 0,
} as const;

export {
  ASSETS_TAB_INDEX,
  SETTLEMENT_DUE_TODAY_IN_DAYS,
  HOME_PANE_LAYOUT_DESIGN_SYSTEM_SETTINGS,
};
